import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControl from '@material-ui/core/FormControl';
import {postFutureCatalog, updateFutureCatalog } from '../../api/featurecatalog';
import Grid from '@material-ui/core/Grid';
import { InputLabel, Input, FormHelperText } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';


import { css } from "@emotion/core";
import {BarLoader} from "react-spinners";

const override = css`
position: absolute;
  top: 50%;
  left: 40%;
  margin: 0 auto;
`;

class AddFeatureType extends Component{

  constructor(props) {
    super(props);
    this.state = {
      name : "",
      scope: "",
      fieldOfApplication: "",
      featureCatalogCode: "",
      versionNumber: "",
      versionDate: "",
      individualName: "",
      organisationName: "",
      voice: "",
      facsimile: "",
      deliveryPoint: "",
      city: "",
      administrativeArea: "",
      postalCode: "",
      country: "",
      electronicMailAddress: "",
      dataUpdate : this.props.data,
      action: "add",
      loading: false
    }
  }

  componentWillMount(){
    console.log(this.state.dataUpdate);
    if(this.state.dataUpdate.length>0){
      this.setState({
        name : this.state.dataUpdate[1],
        scope: this.state.dataUpdate[16],
        featureCatalogCode: this.state.dataUpdate[18],
        fieldOfApplication: this.state.dataUpdate[12],
        versionNumber: this.state.dataUpdate[4],
        versionDate: this.state.dataUpdate[3],
        individualName: this.state.dataUpdate[14],
        organisationName: this.state.dataUpdate[2],
        voice: this.state.dataUpdate[17],
        facsimile: this.state.dataUpdate[10],
        deliveryPoint: this.state.dataUpdate[8],
        city: this.state.dataUpdate[6],
        administrativeArea: this.state.dataUpdate[5],
        postalCode: this.state.dataUpdate[15],
        country: this.state.dataUpdate[7],
        electronicMailAddress: this.state.dataUpdate[9],
        featureCatalogId: this.state.dataUpdate[11],
        id: this.state.dataUpdate[13],
        action: "update"
      })
    }else{
      console.log("add");
    }

  }


  handleChangeText = (keys,e) => {
      this.setState({ [keys]: e.target.value });
  };

  submitForm = () => {
    this.setState({loading:true});
    if(this.state.action == "add"){
      postFutureCatalog(this.state)
        .then(response => {
          //this.props.pushCategory(response.data);
          this.setState({loading:false});
          this.props.handleOpen(false);
          this.props.handleReload(true);
        })
        .catch(error => {
          console.log(error);
        });
    }else{
      updateFutureCatalog(this.state)
        .then(response => {
          //this.props.pushCategory(response.data);
          this.setState({loading:false});
          this.props.handleOpen(false);
          this.props.handleReload(true);
        })
        .catch(error => {
          console.log(error);
        });
    }


  }

  renderInfo = () =>{
    if(this.state.action == "add"){
      return (<Alert severity="info">Add Feature Catalog</Alert>)
    }else{
      return (<Alert severity="info">Edit Feature Catalog</Alert>)
    }
  }

  render(){
    return (
      <span>
      {this.renderInfo()}
      <Grid item xs={12}  >
      <div className="sweet-loading">
        <BarLoader
          css={override}
          height={4}
          width={300}
          color={"#C51162"}
          loading={this.state.loading}
        />
      </div>

      <Grid item xs={6}>
        <FormControl>
          <InputLabel htmlFor="name">Name</InputLabel>
          <Input id="name" aria-describedby="name"
            value = {this.state.name}
            onChange = {(e) => this.handleChangeText("name",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="scope">Scope</InputLabel>
          <Input id="scope" aria-describedby="scope"
            value = {this.state.scope}
            onChange = {(e) => this.handleChangeText("scope",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="fieldOfApplication">fieldOfApplication</InputLabel>
          <Input id="fieldOfApplication" aria-describedby="field Of Application"
            value = {this.state.fieldOfApplication}
            onChange = {(e) => this.handleChangeText("fieldOfApplication",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="versionNumber">versionNumber</InputLabel>
          <Input id="versionNumber" aria-describedby="field Of Application"
            value = {this.state.versionNumber}
            onChange = {(e) => this.handleChangeText("versionNumber",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="versionDate">versionDate</InputLabel>
          <Input id="versionDate" aria-describedby="version Date"
            value = {this.state.versionDate}
            onChange = {(e) => this.handleChangeText("versionDate",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="individualName">individualName</InputLabel>
          <Input id="individualName" aria-describedby="individualName"
            value = {this.state.individualName}
            onChange = {(e) => this.handleChangeText("individualName",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="organisationName">organisationName</InputLabel>
          <Input id="organisationName" aria-describedby="organisationName"
            value = {this.state.organisationName}
            onChange = {(e) => this.handleChangeText("organisationName",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="voice">voice</InputLabel>
          <Input id="voice" aria-describedby="voice"
            value = {this.state.voice}
            onChange = {(e) => this.handleChangeText("voice",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="facsimile">facsimile</InputLabel>
          <Input id="facsimile" aria-describedby="facsimile"
            value = {this.state.facsimile}
            onChange = {(e) => this.handleChangeText("facsimile",e)}
          />
        </FormControl>{' '}
        <FormControl >
          <InputLabel htmlFor="deliveryPoint">Delivery Point</InputLabel>
          <Input id="deliveryPoint" aria-describedby="deliveryPoint"
            value = {this.state.deliveryPoint}
            onChange = {(e) => this.handleChangeText("deliveryPoint",e)}
          />
        </FormControl>{' '}
        <FormControl >
          <InputLabel htmlFor="city">City</InputLabel>
          <Input id="city" aria-describedby="city"
            value = {this.state.city}
            onChange = {(e) => this.handleChangeText("city",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="administrativeArea">Administrative Area</InputLabel>
          <Input id="administrativeArea" aria-describedby="administrative area"
            value = {this.state.administrativeArea}
            onChange = {(e) => this.handleChangeText("administrativeArea",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="postalCode">postalCode</InputLabel>
          <Input id="postalCode" aria-describedby="postalCode"
            value = {this.state.postalCode}
            onChange = {(e) => this.handleChangeText("postalCode",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="country">country</InputLabel>
          <Input id="country" aria-describedby="country"
            value = {this.state.country}
            onChange = {(e) => this.handleChangeText("country",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="electronicMailAddress">electronicMailAddress</InputLabel>
          <Input id="electronicMailAddress" aria-describedby="electronicMailAddress"
            value = {this.state.electronicMailAddress}
            onChange = {(e) => this.handleChangeText("electronicMailAddress",e)}
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="featureCatalogCode">Feature Catalog Code</InputLabel>
          <Input id="featureCatalogCode" aria-describedby="featureCatalogCode"
            value = {this.state.featureCatalogCode}
            onChange = {(e) => this.handleChangeText("featureCatalogCode",e)}
          />
        </FormControl>


      </Grid>
      <Grid item xs={6}>
      <br/>
        <Button variant="contained" color="primary" onClick = {this.submitForm}>Save</Button>

      </Grid>
      </Grid>
      </span>
    )
  }
}

export default AddFeatureType;
